import {DashboardCard} from '../dashboard-card/DashboardCard'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Skeleton} from '@/components/ui/skeleton/Skeleton'

interface DashboardSimpleCardSkeletonProps {
    title?: string
}

export const DashboardSimpleCardSkeleton = ({title}: DashboardSimpleCardSkeletonProps) => {
    return (
        <DashboardCard title={title}>
            <Flexbox direction="column" gap={4} fullWidth>
                {/* Main value skeleton */}
                <Skeleton width="120px" height="32px" />

                {/* Secondary information skeleton */}
                <Flexbox direction="column" gap={2}>
                    <Flexbox align="center" gap={2}>
                        <Skeleton width="60px" height="20px" />
                        <Skeleton width="140px" height="20px" />
                    </Flexbox>
                </Flexbox>
            </Flexbox>
        </DashboardCard>
    )
}
